import { useCallback, useEffect } from 'react';

import { type Form, useFormContext } from 'src/context/FormContext';

interface Props {
  form: Form;
  dirty?: boolean;
}

export const useFormDirtyStateUpdates = ({ form, dirty }: Props) => {
  const formContext = useFormContext();

  const updateFormDirtyState = useCallback(
    ({ dirty: currDirty }: { dirty: boolean }) => {
      formContext.setDirtyState(form, currDirty);
    },
    [formContext, form],
  );

  useEffect(() => {
    if (typeof dirty !== 'undefined') {
      formContext.setDirtyState(form, dirty);
    }

    return () => {
      formContext.setDirtyState(form, false);
    };
  }, [formContext, form, dirty]);

  return updateFormDirtyState;
};
